import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ClaimBtn = styled(Button)<{
  borderRadius?: string;
  height?: string;
}>`
  height: ${({ height }) => (height ? height : "40px")};
  line-height: ${({ height }) => (height ? height : "40px")};
  max-height: ${({ height }) => (height ? height : "40px")};
  width: 90px;
  color: #22d758;
  font-size: 14px;
  font-family: "Gill Sans";
  text-transform: uppercase;
  background: #013310;
  border: none;
  border-radius: ${({ borderRadius }) =>
    borderRadius ? borderRadius : "8px 0"};
  &:hover {
    background: #22d758;
    color: #000000;
  }
  &:disabled {
    &:hover {
      color: #000000 !important;
    }
  }
`;
